import { useFullStoryPageView } from 'hooks/useFullstoryPageView';

import { MainCardRoutingModal } from 'components/common/MainCardRoutingModal/mainCardRoutingModal';
import { BottomHeaderSection } from 'components/common/PageContainer/BottomHeaderSection';
import { HeaderWrapper } from 'components/common/PageContainer/HeaderWrapper';
import { MainContent } from 'components/common/PageContainer/MainContent';
import PageContainer from 'components/common/PageContainer/PageContainer';
import { VersionSection } from 'components/common/PageContainer/versionSection';
import { VersionWrapper } from 'components/common/PageContainer/versionWrapper';
import { PageWidgetWrapper } from 'components/common/PageWidgetWrapper/PageWidgetWrapper';
import { ProgramTopHeader } from 'components/common/ProgramTopHeader/ProgramTopHeader';
import { ShareInsightButton } from 'components/common/ShareInsightButton/ShareInsightButton';

import { CompareTo } from 'components/Dashboards/ExcellenceApps/ClusterRCFAnalysis/CompareTo/CompareTo';
import { GraphComponents } from 'components/Dashboards/ExcellenceApps/ClusterRCFAnalysis/GraphComponents';
import { DurationForecastFilter } from 'components/Dashboards/ExcellenceApps/ClusterRCFAnalysis/durationForecastFilter';
import { NlpThresholds } from 'components/Dashboards/ExcellenceApps/ClusterRCFAnalysis/nlpThresholds/nlpThresholds';
import { riskConfig } from 'components/Dashboards/ExcellenceApps/riskConfig';
import { TreeProgramTopHeader } from 'components/common';

export const DurationForecastPage = () => {
    useFullStoryPageView({ pageName: riskConfig.durationForecast.title });

    return (
        <PageContainer>
            <HeaderWrapper>
                <VersionWrapper>
                    <VersionSection>
                        <TreeProgramTopHeader>
                            <CompareTo />
                            <ShareInsightButton title={riskConfig.durationForecast.title} link={window.location.href} />
                            <NlpThresholds />
                        </TreeProgramTopHeader>
                    </VersionSection>
                </VersionWrapper>
                <BottomHeaderSection>
                    <ProgramTopHeader pageTitle={riskConfig.durationForecast.title} />
                    <DurationForecastFilter />
                </BottomHeaderSection>
            </HeaderWrapper>

            <MainContent>
                <PageWidgetWrapper>
                    <GraphComponents />
                </PageWidgetWrapper>
            </MainContent>

            <MainCardRoutingModal queryKeys={['clustersData', 'clustersDataBySearchWord']} />
        </PageContainer>
    );
};
